import * as colors from '@mehilainen/mds-tokens/colors';
import { buttonClasses, svgIconClasses, } from '@mui/material';
import { focusVisible, muiFocusVisibleCssClass } from '../shared';
import { getButtonSizeStyle } from './utils';
const getButtonStyles = (tokens) => {
    var _a, _b, _c, _d;
    return ({
        defaultProps: {
            color: 'primary',
            variant: 'contained',
            size: 'medium',
        },
        styleOverrides: {
            root: {
                minWidth: 'unset',
                boxShadow: 'none',
                textTransform: 'unset',
                borderRadius: tokens.uiElementButton.borderRadius,
                [`& .${buttonClasses.loadingIndicator}`]: {
                    color: colors.Gray600,
                },
                [`&${muiFocusVisibleCssClass}`]: Object.assign(Object.assign({}, focusVisible), { outlineOffset: '2px' }),
            },
            contained: {
                [`&.${buttonClasses.colorError}`]: {
                    '&:hover': {
                        boxShadow: 'unset',
                        backgroundColor: colors.Error600,
                    },
                    '&:active': {
                        boxShadow: 'unset',
                        backgroundColor: colors.Error800,
                        color: colors.Error200,
                    },
                },
                [`&.${buttonClasses.colorPrimary}`]: {
                    '&:hover': {
                        boxShadow: 'unset',
                        backgroundColor: colors.Primary600,
                    },
                    '&:active': {
                        boxShadow: 'unset',
                        backgroundColor: colors.Primary700,
                        color: colors.Primary200,
                    },
                },
                [`& .${buttonClasses.loadingIndicator}`]: {
                    color: colors.White,
                },
                '&.Mui-disabled': {
                    backgroundColor: colors.Gray600,
                    [`&:not(.${buttonClasses.loading})`]: {
                        color: colors.White,
                    },
                },
            },
            outlined: {
                borderColor: colors.Gray300,
                backgroundColor: colors.White,
                [`&.${buttonClasses.colorError}`]: {
                    '&:hover': {
                        boxShadow: 'unset',
                        backgroundColor: colors.Error100,
                        borderColor: colors.Error600,
                        color: colors.Error600,
                    },
                    '&:active': {
                        boxShadow: 'unset',
                        borderColor: colors.Error800,
                        backgroundColor: colors.Error100,
                        color: colors.Error800,
                    },
                },
                [`&.${buttonClasses.colorPrimary}`]: {
                    '&:hover': {
                        boxShadow: 'unset',
                        backgroundColor: (_a = tokens.uiElementButton.lightHoverColor) !== null && _a !== void 0 ? _a : colors.Gray100,
                        borderColor: colors.Primary600,
                        color: colors.Primary600,
                    },
                    '&:active': {
                        boxShadow: 'unset',
                        borderColor: colors.Primary700,
                        backgroundColor: (_b = tokens.uiElementButton.lightHoverColor) !== null && _b !== void 0 ? _b : colors.Gray100,
                        color: colors.Primary700,
                    },
                },
                '&.Mui-disabled': {
                    borderColor: colors.Gray300,
                    backgroundColor: 'unset',
                    [`&:not(.${buttonClasses.loading})`]: {
                        color: colors.Gray600,
                    },
                },
            },
            text: {
                [`&.${buttonClasses.colorError}`]: {
                    '&:hover': {
                        color: colors.Error600,
                    },
                    '&:active': {
                        backgroundColor: colors.Gray100,
                        color: colors.Error800,
                    },
                },
                [`&.${buttonClasses.colorPrimary}`]: {
                    '&:hover': {
                        backgroundColor: (_c = tokens.uiElementButton.lightHoverColor) !== null && _c !== void 0 ? _c : colors.Gray100,
                        color: colors.Primary600,
                    },
                    '&:active': {
                        backgroundColor: (_d = tokens.uiElementButton.lightHoverColor) !== null && _d !== void 0 ? _d : colors.Gray100,
                        color: colors.Primary700,
                    },
                },
                '&.Mui-disabled': {
                    borderColor: colors.Gray300,
                    [`&:not(.${buttonClasses.loading})`]: {
                        color: colors.Gray600,
                    },
                },
            },
            startIcon: {
                color: 'inherit',
                margin: '0px',
            },
            endIcon: {
                color: 'inherit',
                margin: '0px',
            },
            sizeSmall: Object.assign({}, getButtonSizeStyle('sizeSmall', tokens)),
            sizeMedium: Object.assign({}, getButtonSizeStyle('sizeMedium', tokens)),
            sizeLarge: Object.assign({}, getButtonSizeStyle('sizeLarge', tokens)),
        },
    });
};
export const getThemeButtons = (tokens) => {
    const buttonStyles = getButtonStyles(tokens);
    return {
        MuiButton: buttonStyles,
        // NOTE: Button with Icon works better for our purposes than IconButton
        MuiIconButton: {
            styleOverrides: {
                root: {
                    borderRadius: tokens.uiElementButton.borderRadius,
                    '&:hover': {
                        backgroundColor: 'white',
                    },
                    [`.${svgIconClasses.root}`]: { fontSize: 'inherit' },
                    // TODO: IconButton is used in e.g. DatePicker buttons, these pixels fit there fine but otherwise probably won't
                    '&.Mui-focusVisible': Object.assign(Object.assign({}, focusVisible), { outlineOffset: '-4px' }),
                },
            },
        },
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
    };
};
